export default __webpack_public_path__ + "ticket.67dc126f.png";